import { MoreHorizontal } from 'lucide-react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionMenu, Button } from '@/shared/components';

export function RevisionHoldMenu({
  onRederive,
  onRemove,
}: {
  onRederive?: (trigger: HTMLElement | null) => void;
  onRemove?: (trigger: HTMLElement | null) => void;
}) {
  const trigger = useRef<HTMLButtonElement>(null);
  const { t } = useTranslation('revisionHolds');
  return (
    <ActionMenu
      contentClassName="max-w-[calc(100dvw-1rem)]"
      trigger={
        <Button
          ref={trigger}
          variant="ghost"
          size="icon"
          className="-my-2 min-h-11 min-w-11"
          aria-label="Weitere Aktionen"
        >
          <MoreHorizontal size={18} aria-hidden />
        </Button>
      }
      items={[
        ...(onRederive
          ? [
              {
                label: t('rederive'),
                icon: 'CalendarDays' as const,
                onClick: () => onRederive(trigger.current),
              },
            ]
          : []),
        ...(onRemove
          ? [
              { separator: true as const },
              {
                label: t('remove'),
                icon: 'Trash' as const,
                destructive: true,
                onClick: () => onRemove(trigger.current),
              },
            ]
          : []),
      ]}
    />
  );
}
